import React, { useState, useEffect, useContext } from 'react'
import { NavigationContext } from '../NavigationContext'
import Swiper from 'swiper'
import { Navigation, Mousewheel, Keyboard } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/mousewheel'
import 'swiper/css/keyboard'

function SingleTextImRaum() {
  const [content, setContent] = useState(null)
  const [loading, setLoading] = useState(true)
  const { currentSlug } = useContext(NavigationContext)
  useEffect(() => {
    const fetchTextContent = async () => {
      const textSlug = currentSlug.replace('text-im-raum/', '')
      
      try {
        const response = await fetch(`/wp-json/wp/v2/text-im-raum?slug=${textSlug}&_embed`)
        const data = await response.json()
        
        if (data.length > 0) {
          const text = data[0]
          setContent({
            title: text.title.rendered,
            content: text.content.rendered,
            featuredImage: text._embedded?.['wp:featuredmedia']?.[0]?.source_url
          })
        }
        setLoading(false)
      } catch (error) {
        console.error('Error:', error)
        setLoading(false)
      }
    }

    if (currentSlug.startsWith('text-im-raum/')) {
      fetchTextContent()
    }

    return () => {
      setContent(null)
      const swipers = document.querySelectorAll('.swiper-container')
      swipers.forEach(swiperEl => {
        if (swiperEl.swiper) {
          swiperEl.swiper.destroy()
        }
      })
    }
  }, [currentSlug])
  useEffect(() => {
    if (!loading && content) {
      setTimeout(() => {
        const swipers = document.querySelectorAll('.swiper-container')
        swipers.forEach(swiperEl => {
          if (!swiperEl.swiper) {
            new Swiper(swiperEl, {
              modules: [Navigation, Mousewheel, Keyboard],
              slidesPerView: 'auto',
              spaceBetween: 10,
              centeredSlides: false,
              breakpoints: {
                // Mobile first approach
                320: {
                  slidesPerView: 1.2, // Shows 1 full slide + 20% of next slide
                  spaceBetween: 10
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 10
                }
              },
              navigation: {
                nextEl: '.custom-swiper-next',
                prevEl: '.custom-swiper-prev',
              },
              mousewheel: false,
              keyboard: {
                enabled: true
              }
            })
          }
        })
      }, 0)
    }
  }, [loading, content])

  if (!currentSlug.startsWith('text-im-raum/')) return null
  if (loading) return <div>Loading...</div>
  if (!content) return null

  // Extract the specific text title from the slug
  const textTitle = currentSlug.replace('text-im-raum/', '')
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')

  return (
    <main className="single-text-container">
      <header className="page-header">
        <h1 className="page-title">
          <span className="main-title">Text im Raum</span>
          <span className="subtitle"> : <em>{content.title}</em></span>
        </h1>
      </header>
      
      <div dangerouslySetInnerHTML={{ __html: content.content }} />
    </main>
  )
}export default SingleTextImRaum